import { render, staticRenderFns } from "./WorkspaceSettingsForm.vue?vue&type=template&id=604e7f2a"
import script from "./WorkspaceSettingsForm.vue?vue&type=script&lang=js"
export * from "./WorkspaceSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports